import { render, staticRenderFns } from "./sh_AllProjects.vue?vue&type=template&id=535264f0&scoped=true&"
import script from "./sh_AllProjects.vue?vue&type=script&lang=js&"
export * from "./sh_AllProjects.vue?vue&type=script&lang=js&"
import style0 from "./sh_AllProjects.vue?vue&type=style&index=0&id=535264f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535264f0",
  null
  
)

export default component.exports